import { values } from './_helpers'

const _enum = {
  or: 0,
  and: 1
}

const logicOptions = { ..._enum, name: 'logicOptions', values: values(_enum) }

export {
  logicOptions
}
